var map = {
	"./button.svg": "GaKZ",
	"./calendar.svg": "0CxH",
	"./check-circle-active.svg": "gk6z",
	"./create.svg": "SBNf",
	"./detail.svg": "WQGZ",
	"./export.svg": "bhXg",
	"./import.svg": "c6aZ",
	"./info.svg": "NZlI",
	"./list.svg": "yamL",
	"./table.svg": "Jbre"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JUQv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/icon-active ^\.\/.*\.svg$
// module id = JUQv
// module chunks = 46